// Utility function to make a string uppercase
export const toUpperCase = (str) => {
  if (!str) return "";
  return str.toUpperCase();
};

// Utility function to capitalize the first letter of each word in a string
export const capitalizeWords = (str) => {
  if (!str) return "";
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

// Utility function to capitalize only the first letter of a string
export const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

// Utility function to convert a string to lowercase
export const toLowerCase = (str) => {
  if (!str) return "";
  return str.toLowerCase();
};

// Utility function to check if a string contains only alphabets
export const isAlpha = (str) => {
  if (!str) return false;
  return /^[A-Za-z]+$/.test(str);
};

// Utility function to truncate a string to a specified length and add "..."
export const truncateString = (str, maxLength) => {
  if (!str || str.length <= maxLength) return str;
  return str.slice(0, maxLength) + "...";
};

// Utility function to reverse a string
export const reverseString = (str) => {
  if (!str) return "";
  return str.split("").reverse().join("");
};

// Utility function to check if a string is a palindrome
export const isPalindrome = (str) => {
  if (!str) return false;
  const sanitized = str.replace(/[^A-Za-z0-9]/g, "").toLowerCase();
  return sanitized === reverseString(sanitized);
};

// Utility function to convert a string to kebab-case
export const toKebabCase = (str) => {
  if (!str) return "";
  return str
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/\s+/g, "-")
    .toLowerCase();
};

// Utility function to convert a string to snake_case
export const toSnakeCase = (str) => {
  if (!str) return "";
  return str
    .replace(/([a-z])([A-Z])/g, "$1_$2")
    .replace(/\s+/g, "_")
    .toLowerCase();
};

// Utility function to format date
export const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

export const removeUnderScore = (input) => {
  if (input) {
    return input
      .split('_') // Split the string into words by underscore
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(' '); // Join the words with a space
  }
};
